/**
 * Pillar Navigation Module
 * Handles sticky navigation with table of contents and progress tracking
 */

document.addEventListener('DOMContentLoaded', () => {
	const sections = Array.from(
		document.querySelectorAll('section.ArticleBlock'),
	)
	const progressBar = document.querySelector('.pillar-nav__progress')
	const prevButton = document.querySelector('.pillar-nav__prev')
	const nextButton = document.querySelector('.pillar-nav__next')
	const currentSectionLabel = document.querySelector(
		'.pillar-nav__curr-section',
	)
	const tocTrigger = document.querySelector('.pillar-nav__toc-trigger')
	const tocContainer = document.querySelector('.pillar-nav__toc')
	const tocList = document.querySelector('.pillar-nav__toc-items')

	// Exit if pillar nav elements don't exist
	if (!progressBar || !tocList) return

	const getNavHeight = () => {
		const nav = document.querySelector('.pillar-nav')
		return nav ? nav.offsetHeight + 16 : 64
	}

	// Populate the Table of Contents
	sections.forEach((section) => {
		const heading = section.querySelector('h1')
		if (heading) {
			const listItem = document.createElement('li')
			const link = document.createElement('a')
			link.href = `#${section.id}`
			link.textContent = heading.textContent
			link.classList.add(
				'block',
				'text-sm',
				'hover:text-primary',
				'pillar-nav__toc-link',
			)
			listItem.appendChild(link)
			tocList.appendChild(listItem)
		}
	})

	// Update Navigation and Progress Bar
	const updateNavigation = () => {
		const scrollTop = window.scrollY + window.innerHeight / 2
		let currentIndex = -1

		// Determine the current section
		sections.forEach((section, index) => {
			const sectionTop = section.offsetTop
			const sectionBottom = sectionTop + section.offsetHeight
			if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
				currentIndex = index
			}
		})

		// Handle scrolling past the last section
		if (
			currentIndex === -1 &&
			sections.length > 0 &&
			scrollTop >
				sections[sections.length - 1].offsetTop +
					sections[sections.length - 1].offsetHeight
		) {
			currentIndex = sections.length - 1
		}

		// Update current section label
		if (currentIndex !== -1 && currentSectionLabel) {
			const currentHeading = sections[currentIndex].querySelector('h1')
			currentSectionLabel.textContent = currentHeading
				? currentHeading.textContent
				: `Section ${currentIndex + 1}`
		} else if (currentSectionLabel) {
			currentSectionLabel.textContent = ''
		}

		// Update Prev/Next Buttons
		if (prevButton) {
			if (currentIndex > 0) {
				prevButton.href = `#${sections[currentIndex - 1].id}`
				prevButton.classList.remove('text-neutral-600')
			} else {
				prevButton.removeAttribute('href')
				prevButton.classList.add('text-neutral-600')
			}
		}

		if (nextButton) {
			if (currentIndex >= 0 && currentIndex < sections.length - 1) {
				nextButton.href = `#${sections[currentIndex + 1].id}`
				nextButton.classList.remove('text-neutral-600')
			} else {
				nextButton.removeAttribute('href')
				nextButton.classList.add('text-neutral-600')
			}
		}

		// Update progress bar
		const scrollHeight =
			document.documentElement.scrollHeight - window.innerHeight
		const progress =
			scrollHeight > 0 ? (window.scrollY / scrollHeight) * 100 : 0
		progressBar.style.width = `${progress}%`

		// Highlight active ToC link
		document.querySelectorAll('.pillar-nav__toc-link').forEach((link) => {
			link.classList.remove('text-primary')
		})
		if (currentIndex !== -1) {
			const activeLink = tocList.querySelector(
				`a[href="#${sections[currentIndex].id}"]`,
			)
			if (activeLink) {
				activeLink.classList.add('text-primary')
			}
		}
	}

	// Toggle ToC visibility
	if (tocTrigger && tocContainer) {
		tocTrigger.addEventListener('click', () => {
			const isExpanded = tocTrigger.getAttribute('aria-expanded') === 'true'
			tocTrigger.setAttribute('aria-expanded', !isExpanded)
			tocContainer.classList.toggle('hidden')
		})
	}

	// Smooth scrolling for pillar navigation links (TOC and arrows)
	document
		.querySelectorAll(".pillar-nav a[href^='#'], .pillar-nav__arrow")
		.forEach((anchor) => {
			anchor.addEventListener('click', (e) => {
				const href = anchor.getAttribute('href')
				if (!href || href === '#') return

				e.preventDefault()
				const target = document.querySelector(href)
				if (target) {
					const targetPosition = target.offsetTop - getNavHeight()
					window.scrollTo({
						top: targetPosition,
						behavior: 'smooth',
					})
				}
			})
		})

	// Scroll event listener
	window.addEventListener('scroll', updateNavigation)
	updateNavigation() // Initialize on page load
})
